import '@hotwired/turbo-rails'
import '../controllers'
import '../stream_actions/show_modal'
import '../stream_actions/show_toast'
import '../service_worker'
import "chartkick/chart.js"
import { Chart } from "chart.js"

Chart.defaults.font.family = "Noto Sans JP"
